import {
  Component,
  ElementRef,
  ViewChild,
  HostListener,
  Input,
  TemplateRef,
  ContentChild, OnChanges, SimpleChanges
} from '@angular/core';
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: 'app-overflow-list',
  templateUrl: './overflow-list-button.component.html',
  standalone: true,
  imports: [
    NgTemplateOutlet
  ],
  styleUrls: ['./overflow-list-button.component.scss']
})
export class OverflowListComponent implements OnChanges {
  @ViewChild('container', { static: true }) containerRef!: ElementRef;
  @Input({required: true}) items!: { label: string }[];

  @ContentChild('itemTemplate') itemTemplate?: TemplateRef<any>;
  @ContentChild('separatorTemplate') separatorTemplate?: TemplateRef<any>;
  @ContentChild('moreButtonTemplate') moreButtonTemplate?: TemplateRef<any>;

  visibleItems: { label: string }[] = [];
  hiddenItems: { label: string }[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
      this.calculateVisibleItems();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.calculateVisibleItems();
  }

  calculateVisibleItems() {
    const containerWidth = this.containerRef.nativeElement.offsetWidth;

    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.display = 'flex';
    tempDiv.style.whiteSpace = 'nowrap';
    document.body.appendChild(tempDiv);

    let totalWidth = 0;
    const visible: { label: string }[] = [];

    for (let item of this.items) {
      const itemDiv = document.createElement('div');
      itemDiv.className = 'item';
      itemDiv.innerText = item.label;
      tempDiv.appendChild(itemDiv);
      const itemWidth = itemDiv.offsetWidth + 8; // margin compensation
      totalWidth += itemWidth;

      if (totalWidth <= containerWidth - 60) {
        visible.push(item);
      } else {
        break;
      }
    }

    document.body.removeChild(tempDiv);

    this.visibleItems = visible;
    this.hiddenItems = this.items.slice(visible.length);
  }

  isLastItem(item: { label: string }) {
    return this.items.indexOf(item) === this.items.length - 1;
  }
}
